<template>
  <div class="modal__wrap--bg cmp-modal" :class="{'is-active' : giveUpRegistModal}" id="give-up-regist-template">
    <div class="modal-wrap-container modal-wd1020">
      <div class="modal-header">
        <div class="title">중도포기 등록</div>
      </div>
      <div class="modal-body-container">
        <div class="table-wrap border-top-none mt-0">
          <table class="table-body-only">
            <caption>중도포기 등록 정보 테이블</caption>
            <colgroup class="pc-cell">
              <col style="width: 160px;" />
              <col />
            </colgroup>
            <colgroup class="mo-cell">
              <col style="width: 88px;" /> 
              <col />
            </colgroup>
            <tbody>
              <tr>
                <th scope="row">사업연도</th>
                <td>{{ detail.BIZ_YEAR }}</td>
              </tr>
              <tr>
                <th scope="row">세부사업명</th>
                <td>{{ detail.BIZNM }}</td>
              </tr>
              <tr>
                <th scope="row">참여자 단계</th>
                <td>{{ curStatCdNm }}</td>
              </tr>
              <tr>
                <th scope="row">중도포기일</th>
                <td>
                  <div class="input-area mo-size wid200">
                    <input type="date" v-model="giveupDate" max="9999-12-31" title="중도포기일">
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">포기사유</th>
                <td>
                  <div class="radio-group" v-if="annKindType === 'JB'">
                    <label class="radio-item">
                      <input type="radio" name="give-up" value="1" v-model="giveupRsn" title="give-up 선택">
                      <span class="custom-radio"></span>
                      취업
                    </label>
                    <label class="radio-item">
                      <input type="radio" name="give-up" value="2" v-model="giveupRsn" title="give-up 선택">
                      <span class="custom-radio"></span>
                      창업
                    </label>
                    <label class="radio-item">
                      <input type="radio"  name="give-up" value="3" v-model="giveupRsn" title="give-up 선택">
                      <span class="custom-radio"></span>
                      개인사유
                    </label>
                    <label class="radio-item">
                      <input type="radio"  name="give-up" value="0" v-model="giveupRsn" title="give-up 선택">
                      <span class="custom-radio"></span>
                      기타
                    </label>
                  </div>
                  <div class="radio-group" v-else>
                    <label class="radio-item" v-for="item in giveupRsnCodes" :key="item.code">
                      <input type="radio" name="give-up" :value="item.code" v-model="giveupRsn" title="give-up 선택">
                      <span class="custom-radio"></span>
                      {{ item.name }}
                    </label>
                  </div>
                </td>
              </tr>
              <tr>
                <th scope="row">포기사유 상세</th>
                <td>
                  <div class="input-area wid100p">
                    <input type="text" v-model="meanGiveupRsn" title="포기사유 상세">
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary btn-md button-wid150" @click="close">
          닫기
        </button>
        <button type="button" class="btn btn-primary btn-md button-wid150" @click="giveupRegist">
          저장하기
        </button>
      </div>
      <button type="button" class="btn btn-close only-icon close-modal" aria-label="닫기" @click="close" title="닫기">
        <i class="ico ico-x-bl"></i>
      </button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios';

export default {
  name: 'give-up-regist-template',
  props: ['detail', 'giveUpRegistModal', 'annKindType'],
  components: {},
  data() {
    return {
      appNo: '',
      curStatCd: '',
      curStatCdNm: '',
      giveupDate: '',
      meanGiveupRsn: '',
      giveupRsn: '',
      giveupRsnCodes: [],
    };
  },
  watch: {
    giveUpRegistModal: {
      handler(newVal) {
        console.log(newVal);
      },
    },
    detail: {
      handler(newVal) {
        this.annNo = newVal.ANN_NO;
        this.appNo = newVal.APP_NO;
        this.curStatCd = newVal.CUR_STAT_CD;
        this.curStatCdNm = newVal.CUR_STAT_CD_NM;
        this.giveupDate = newVal.giveupDate;
        this.meanGiveupRsn = newVal.meanGiveupRsn;
        this.giveupRsn = newVal.giveupRsn;
        this.getIN54Codes();
      },
    },
  },
  methods: {
    giveupRegist() {
      if (this.giveupDate === '') {
        alert('중도포기일을 입력해주세요.');
      }

      if (this.giveupRsn === '') {
        alert('포기사유를 선택해주세요');
      }

      if (this.giveupRsn.length > 1000) {
        alert('1000자 이내로 작성하여 주십시오.');
      }

      const params = {
        APP_NO: this.appNo,
        CUR_STAT_CD: this.curStatCd,
        GIVEUPDATE: this.giveupDate,
        MEAN_GIVEUP_RSN: this.meanGiveupRsn,
        GIVEUP_RSN: this.giveupRsn,
        GIVEUP_RSN_CD: this.giveupRsn,
      };
      const url = (this.annKindType === 'JB') ? '/giveupInsertAjaxMypage' : '/in_giveupInsertAjaxMypage';
      $.ajax({
        url: url,
        type: 'POST',
        data: params,
        success: (response) => {
          alert("중도포기 등록이 완료되었습니다.");
          this.close();
        }
      });
      // Axios.post(url, params).then((response) => {
      //   console.log(response);
      // }).catch((e) => {
      //   console.log(e);
      // });
    },
    getIN54Codes() {
      Axios.get('/api/common-codes/getCodes?parentCode=IN54')
        .then((response) => {
          this.giveupRsnCodes = response.data;
        }).catch((e) => {
          console.log(e);
        });
    },
    close() {
      this.$emit('update:giveUpRegistModal', false);
    },
  },
  mounted() {},
};
</script>



// WEBPACK FOOTER //
// GiveUpRegist.vue?6c2035e7